import { render, staticRenderFns } from "./CaptchaComponent.vue?vue&type=template&id=c002dfd4&"
import script from "./CaptchaComponent.vue?vue&type=script&lang=js&"
export * from "./CaptchaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports